export const getColor = ({ theme, color }) => {
    if (!color || ["default", "inherit"].includes(color))
        return "inherit";
    const { palette } = theme.vars;
    const paletteColor = color in palette ? palette[color] : undefined;
    return paletteColor && typeof paletteColor === "object" && "main" in paletteColor ? paletteColor.main : color;
};
export const getContrastColor = ({ theme, color }) => {
    const { palette } = theme.vars;
    if (!color || ["default", "inherit"].includes(color))
        return palette.surface.main;
    const paletteColor = color in palette ? palette[color] : undefined;
    return paletteColor && typeof paletteColor === "object" && "contrastText" in paletteColor
        ? paletteColor.contrastText
        : palette.surface.main;
};
export const getContainedHoverColor = ({ theme, color, }) => {
    const { palette } = theme.vars;
    if (!color || ["default", "inherit"].includes(color))
        return palette.primary.onFixed;
    const paletteColor = color in palette ? palette[color] : undefined;
    return paletteColor && typeof paletteColor === "object" && "onFixed" in paletteColor
        ? paletteColor.onFixed
        : palette.primary.onFixed;
};
